export const painPoints = [
  {
    emoji: '🧭',
    title: 'You don’t know where to start',
    desc: 'The blank screen is your enemy. This method organizes everything: Motions, evidence, and narratives.',
  },
  {
    emoji: '🔤',
    title: 'You struggle with AI precision',
    desc: 'Stop guessing. Use attorney-vetted structures that sound professional and clinical, not robotic.',
  },
  {
    emoji: '🧩',
    title: 'You fear the "AI Red Flag"',
    desc: 'Generic AI sounds fake. Our system ensures your documents sound like a 30-year veteran wrote them.',
  },
  {
    emoji: '🎯',
    title: 'You want to reclaim your life',
    desc: 'Spending 4 hours on a single brief after a long day in court is not sustainable.',
  },
];
